import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Search as SearchIcon, Edit as EditIcon } from "@mui/icons-material";

const TransferModal = ({ transferDetails, handleEdit }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredTransferDetails = Array.isArray(transferDetails)
    ? transferDetails.filter((item) => {
        const vesselName = item.contractDetails?.ShipDetails?.vesselname?.toLowerCase() || "";
        const crewName = item.contractDetails?.crewdetails?.name?.toLowerCase() || "";
        return vesselName.includes(searchQuery) || crewName.includes(searchQuery);
      })
    : [];

  return (
    <Box mt={3} width="100%" p={2}>
      {/* Search Bar & Title */}
      <Box
        sx={{
          p: 1,
          bgcolor: "#C30B12",
          color: "white",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* Search Input */}
        <TextField
          placeholder="Search by Vessel Name or Crew Name"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: "280px",
          }}
        />

        {/* Centered Title */}
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
          }}
        >
          Transfer Details
        </Typography>
      </Box>

      {/* Table Section */}
      <Paper elevation={3} sx={{ p: 2 }}>
        {filteredTransferDetails.length > 0 ? (
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTransferDetails.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Vessel Name: {item.contractDetails?.ShipDetails?.vesselname || "N/A"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Crew: {item.contractDetails?.crewdetails?.name || "N/A"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Agent: {item.contractDetails?.crewingAgent?.agentName || "N/A"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Transfer Date:{" "}
                      {item.contractStatusAfterForm1?.transfer[0]?.Date
                        ? new Date(item.contractStatusAfterForm1.transfer[0].Date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })
                        : "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => handleEdit(item.contractDetails?._id)}
                      color="primary"
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography color="textSecondary" align="center">
            No transfer details found.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default TransferModal;
